window.history.scrollRestoration = "manual";
window.addEventListener('load', () => {
  window.scrollTo({
    top: 0,
    behavior: 'instant' // instantané
  });
});
document.addEventListener("DOMContentLoaded", function() {
 
  window.scrollTo(0, 0);

  /* Home Logo animation */

  const element = document.querySelector('body.get_index header');
  const biglogo = document.querySelector('#shopify-section-template--27102355292485__section_Fh7TFQ');
  const formaterIndex = document.querySelector('#shopify-section-template--27102355292485__section_Fh7TFQ rte-formatter');

  if ( formaterIndex ){

    formaterIndex.style.opacity = 1;

  }

  if ( element ){

    window.addEventListener('scroll', () => {
      element.classList.add('active');
      biglogo.classList.add('active');
      element.classList.add('after');

    });

  }

  /* Custom Nav Slider Featured product */

  const sliderFeaturedProduct = document.querySelector('.card-gallery-ANWRFUUl4dUVKMWM3Y__featured-product-gallery');


  if ( sliderFeaturedProduct ){
 
    const sliderComponent = sliderFeaturedProduct.querySelector('slideshow-component slideshow-container');

    // <slideshow-arrows position="center">
    const slideshowArrows = document.createElement("slideshow-arrows");
    slideshowArrows.setAttribute("position", "center");

    // ---------------------------------------------
    // Fonction utilitaire pour créer un bouton flèche
    // ---------------------------------------------
    function createArrowButton({ isNext = false }) {
      const btn = document.createElement("button");

      btn.className = `
        get_customSlidesShowControl
        slideshow-control
        slideshow-control--${isNext ? "next" : "previous"}
        slideshow-control--style-arrow
        button button-unstyled button-unstyled--transparent
        ${isNext ? "" : "flip-x"}
      `.replace(/\s+/g, " ").trim();

      btn.setAttribute("aria-label", isNext ? "Next slide" : "Previous slide");
      btn.setAttribute("on:click", isNext ? "/next" : "/previous");
      btn.setAttribute("ref", isNext ? "next" : "previous");

      // <span class="svg-wrapper icon-arrow">
      const span = document.createElement("span");
      span.className = "svg-wrapper icon-arrow";

      // SVG
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svg.setAttribute("viewBox", "0 0 20 20");
      svg.setAttribute("fill", "none");

      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("stroke", "currentColor");
      path.setAttribute("stroke-linecap", "round");
      path.setAttribute("stroke-linejoin", "round");
      path.setAttribute("stroke-width", "var(--icon-stroke-width)");
      path.setAttribute("vector-effect", "non-scaling-stroke");
      path.setAttribute("d", "M4.25 10h11.5m0 0-4-4m4 4-4 4");

      svg.appendChild(path);
      span.appendChild(svg);
      btn.appendChild(span);

      return btn;
    }

    // Créer les deux boutons
    const previousBtn = createArrowButton({ isNext: false });
    const nextBtn = createArrowButton({ isNext: true });

    // Ajouter au container
    slideshowArrows.appendChild(previousBtn);
    slideshowArrows.appendChild(nextBtn);

    // Insérer avant le slider
    sliderComponent.prepend(slideshowArrows);


    // Event

    document.addEventListener('click', function(e) {
      // Récupérer le bouton cliqué
      const btn = e.target.closest('.get_customSlidesShowControl');
      if (!btn) return;

      e.preventDefault();

      // Parent du slideshow
      const thisParent = btn.closest('slideshow-container');
      if (!thisParent) return;
      // Slide actif = celui qui n'a pas l'attribut hidden
      const slideActive = thisParent.querySelector('slideshow-slides slideshow-slide:not([hidden])');
      if (!slideActive) return;

      let targetSlide;
      
      if (btn.classList.contains('slideshow-control--next')) {

        // Slide suivant
        targetSlide = slideActive.nextElementSibling;
        if (!targetSlide) {
          targetSlide = thisParent.querySelector('slideshow-slides slideshow-slide');
        }

      }else{

        targetSlide = slideActive.previousElementSibling;
        if (!targetSlide) {
          const slides = thisParent.querySelectorAll('slideshow-slides slideshow-slide');
          targetSlide = slides[slides.length - 1];
        }

      }

      // --- Synchroniser avec le swatch ---
      const parentCard = btn.closest('.product-card__content');
      if (!parentCard) return;

      const labelSwatches = parentCard.querySelectorAll('product-swatches overflow-list .variant-option__swatch');

      // Déterminer l'index du slide suivant
      const slidesArray = Array.from(thisParent.querySelectorAll('slideshow-slides slideshow-slide'));
      const nextIndex = slidesArray.indexOf(targetSlide);

      // Cliquer sur le swatch correspondant
      if (labelSwatches[nextIndex]) {
        labelSwatches[nextIndex].querySelector('input').click();
      }

      // --- Mettre à jour l'attribut hidden pour les slides ---
      slideActive.setAttribute('hidden', '');
      targetSlide.removeAttribute('hidden');
    });


  }

});